import ApiClient from '../../../lib/api/ApiClient';
import { createCallsheetsHooks } from './callsheets.hooks';
import { createCallsheetsApi } from './callsheets.http';

export const callsheets = createCallsheetsHooks(
  // @ts-ignore -- ApiClient type is defined based on ApiClient pure js class
  createCallsheetsApi(new ApiClient(), true)
);
